import { Row, Col, Modal, Form, Input, Tabs, Badge } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import languages from "../../config/language";
import StateSelect from "../../components/select/StateSelect";
import { INDIA_COUNTRY, MAKE_URL } from "../../constants/conts";
const { TabPane } = Tabs;

const From = ({ path, sectionName, show, hide, data, refresh }) => {

  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [validationStatus, setValidationStatus] = useState({});
  const [selectedState, setSelectedState] = useState(null);

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
  }, [data])

  const handleFieldChange = (data, lang, type) => {

    const name = form.getFieldValue(`${lang}_name`);

    setValidationStatus(prevStatus => ({
      ...prevStatus,
      [lang]: !!name
    }));
  }

  const onCreate = (values) => {

    const payload = {
      ...values,
    }

    setLoading(true);
    request({
      url: MAKE_URL(path, data),
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    })
  };

  const handleStateChange = (stateId) => {
    setSelectedState(stateId);
  };

  useEffect(() => {
    const initialValidationStatus = {};
    
    languages.forEach(lang => {
        initialValidationStatus[lang.short] = !!form.getFieldValue(`${lang.short}_name`);
    });

    setValidationStatus(initialValidationStatus);
  }, [])

  return (
    <Modal
      open={show}
      title={`${data ? 'Update ' + sectionName : 'Create a New ' + sectionName}`}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">

        <Row gutter={[16, 16]}>

          <Col span={24} xs={12} sm={12} md={24}>
            <Form.Item
              name="state_id"
              label="Select State"
              rules={[{ required: true, message: "Missing State Selection" }]}
            >
              <StateSelect
                countryId={INDIA_COUNTRY}
                onChange={handleStateChange}
              />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={24}>

            <Tabs defaultActiveKey={languages[0].short}>
              
              {languages.map(lang => (

                <TabPane tab={<span>{lang.long} {validationStatus[lang.short] === false && <Badge dot color="red" />}</span>} key={lang.short}>

                  <Form.Item label={`Name (${lang.long})`} name={`${lang.short}_name`}
                    rules={[
                      ...(lang.short === 'en' ? [
                        { required: true, message: `Please enter the name in ${lang.long}!` }
                      ] : []),
                      { max: 100, message: "Name should not contain more than 100 characters!" },
                      { min: 2, message: "Name should contain at least 2 characters!" },
                    ]}
                    initialValue={form.getFieldValue(`${lang.short}_name`)}
                    onChange={(data) => handleFieldChange(data, lang.short, 'title')}
                  >

                    <Input autoComplete="off" placeholder={`Enter name in ${lang.long}`} />

                  </Form.Item>
                </TabPane>
              ))}
            </Tabs>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
};

export default From;